import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/report-payroll-nss',
    name: 'report-payroll-nss',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-payroll-nss/index.vue'),
    beforeEnter: async (to, from, next) => {
      await Promise.all([store.dispatch('hr/reportPayrollNss/fetchOrgStructures')])

      next()
    }
  }
]
